export const companyConstants = {
  ADD_COMPANY: "ADD_COMPANY",
  DELETE_COMPANY: "DELETE_COMPANY",
  UPDATE_COMPANY: "UPDATE_COMPANY",
  GET_ALL_COMPANIES: "GET_ALL_COMPANIES",
  CREATE_DUMMY_COMPANY: "CREATE_DUMMY_COMPANY",
  GET_CURRENT_STORE_COMPANY_DETAILS: "GET_CURRENT_STORE_COMPANY_DETAILS",
};
